import moment from 'moment';
import { EMAIL_DATE_FORMAT } from 'constants/config';

export default message => (`
    <br>
    <br>
    <div>
    ---------- Forwarded message ---------
    <br>
    From:
    <strong class="gmail_sendername" dir="auto">${message.sent_from_name}</strong>
    <span dir="auto">
        &lt;<a href="mailto:${message.sent_from_email}" target="_blank">${message.sent_from_email}</a>&gt;
    </span>
    <br>
    Date: ${moment(message.received_date).local().format(EMAIL_DATE_FORMAT)}
    <br>
    Subject: ${message.subject}
    <br>
    To: ${message.sent_to.map(to => `${to.name} &lt;
        <a href="mailto:${to.email}" target="_blank">${to.email}</a> &gt;
    `)}
    <br>
    <br>
    </div>
`);
